import React from 'react';
import { Card, Button, Space, Upload, message } from 'antd';
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import NodePalette from './NodePalette';
import PropertiesPanel from './PropertiesPanel';
import s from '../../s.module.less';

interface ISidebarProps {
    questions: any[];
    onAddNode: (nodeType: string, position?: { x: number; y: number }) => void;
    onImportJson: (jsonData: any) => void;
    selectedNode?: any;
    onNodeConfigChange?: (nodeId: string, config: any) => void;
}

const Sidebar: React.FC<ISidebarProps> = ({
    questions,
    onAddNode,
    onImportJson,
    selectedNode,
    onNodeConfigChange,
}) => {
    const handleImport = (file: File) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const jsonData = JSON.parse(e.target?.result as string);
                onImportJson(jsonData);
                message.success('JSON imported successfully');
            } catch (error) {
                message.error('Failed to parse JSON file');
            }
        };
        reader.readAsText(file);
        return false; // Prevent default upload behavior
    };

    const handleExport = () => {
        // This would be handled by the parent component
        message.info('Export functionality will be implemented');
    };

    return (
        <div className={s.sidebar}>
            <div className={s.section}>
                <div className={s.sectionTitle}>Node Palette</div>
                <NodePalette onAddNode={onAddNode} />
            </div>

            <div className={s.section}>
                <div className={s.sectionTitle}>Import/Export</div>
                <Space direction="vertical" style={{ width: '100%' }}>
                    <Upload
                        accept=".json"
                        beforeUpload={handleImport}
                        showUploadList={false}
                    >
                        <Button icon={<UploadOutlined />} block>
                            Import JSON
                        </Button>
                    </Upload>
                    <Button
                        icon={<DownloadOutlined />}
                        onClick={handleExport}
                        block
                    >
                        Export JSON
                    </Button>
                </Space>
            </div>

            {selectedNode && (
                <div className={s.section}>
                    <div className={s.sectionTitle}>Properties</div>
                    <PropertiesPanel
                        node={selectedNode}
                        questions={questions}
                        onConfigChange={onNodeConfigChange}
                    />
                </div>
            )}
        </div>
    );
};

export default Sidebar;
